import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-u-small', 'IconLetterUSmall', [
  ['path', { d: 'M10 8v6a2 2 0 1 0 4 0v-6', key: 'svg-0' }],
]);
